import { gql } from '@apollo/client'

export const RENEW_BATCHES_MUTATION = gql`
  mutation renewBatches($input: RenewBatchesDtoInput!) {
    renewBatches(input: $input) {
      id
      isSentToXero
      isSuccess
    }
  }
`

export const RENEW_ALL_BATCHES_MUTATION = gql`
  mutation renewAllBatches {
    renewAllBatches {
      id
      isSentToXero
      isSuccess
    }
  }
`

export const RETRY_FAILED_BATCH_MUTATION = gql`
  mutation retryFailedBatch($batchId: Long!) {
    retryFailedBatch(batchId: $batchId) {
      id
      isSentToXero
      isSuccess
      errorMessage
    }
  }
`

export const CREATE_MANUAL_BATCHES_MUTATION = gql`
  mutation createManualBatches($accountPayableRecordIds: [Long!]!) {
    createManualBatches(accountPayableRecordIds: $accountPayableRecordIds) {
      success
      warning
      error
    }
  }

`
export const SEND_BATCHES_TO_XERO_MUTATION = gql`
  mutation sendBatchesToXero($batchIds: [Long!]!) {
    sendBatchesToXero(batchIds: $batchIds)
  }
`
